import React from 'react';
import {Container} from 'flux/utils';
import Actions from './Actions';

import Login from './views/landpages/Login.jsx';
import Admin from './views/landpages/Admin.jsx';
import Lottery from './views/landpages/Lottery.jsx';
import Dialog from './views/controls/Dialog.jsx';
import AdminPageTypes from './views/AdminPageTypes';
import Permissions from './domain/Permissions';
import BuildTypes from './utils/BuildTypes';

import ApostilasStore from './stores/ApostilasStore';
import AppStore from './stores/AppStore';
import CityStore from './stores/CityStore';
import CredenciamentoStore from './stores/CredenciamentoStore';
import DialogStore from './stores/DialogStore';
import EventsStore from './stores/EventsStore';
import ImportacaoStore from './stores/ImportacaoStore';
import ImportacaoProdutosStore from './stores/ImportacaoProdutosStore';
import LoginStore from './stores/LoginStore';
import LogStore from './stores/LogStore';
import NucleoStore from './stores/NucleoStore';
import ParticipantesStore from './stores/ParticipantesStore';
import TokenStore from './stores/TokenStore';
import UserStore from './stores/UserStore';
import ProdutosStore from './stores/ProdutosStore';
import LojaVendaStore from './stores/LojaVendaStore';
import LojaCaixaStore from './stores/LojaCaixaStore';
import RelatorioDashboardStore from './stores/RelatorioDashboardStore';
import RelatorioVendasDosNucleosStore from './stores/RelatorioVendasDosNucleosStore';
import RelatorioVendasParaNucleosStore from './stores/RelatorioVendasParaNucleosStore';
import RelatorioVendasPorProdutosStore from './stores/RelatorioVendasPorProdutosStore';
import DistribuicaoVendasStore from './stores/DistribuicaoVendasStore';
import AcumuladoVendasStore from './stores/AcumuladoVendasStore';
import PresencaStore from './stores/PresencaStore';
import LojaExpedicaoStore from './stores/LojaExpedicaoStore';
import PerfisStore from './stores/PerfisStore';
import UsersStore from './stores/UsersStore';
import LojaStore from './stores/LojaStore';
import ProdutosGerenciaStore from './stores/ProdutosGerenciaStore';
import EmailEditorStore from './stores/EmailEditorStore';
import SorteioStore from './stores/SorteioStore';
import LojaPedidosStore from './stores/LojaPedidosStore';

class AppContainer extends React.Component {
    static getStores() {
        return [
            ApostilasStore,
            AppStore,
            CityStore,
            CredenciamentoStore,
            DialogStore,
            EventsStore,
            ImportacaoStore,
            ImportacaoProdutosStore,
            LoginStore,
            LogStore,
            NucleoStore,
            ParticipantesStore,
            TokenStore,
            UserStore,
            ProdutosStore,
            LojaVendaStore,
            LojaCaixaStore,
            PresencaStore,
            LojaExpedicaoStore,
            PerfisStore,
            UsersStore,
            LojaStore,
            ProdutosGerenciaStore,
            RelatorioDashboardStore,
            RelatorioVendasDosNucleosStore,
            RelatorioVendasParaNucleosStore,
            RelatorioVendasPorProdutosStore,
            DistribuicaoVendasStore,
            AcumuladoVendasStore,
            EmailEditorStore,
            SorteioStore,
            LojaPedidosStore,
        ];
    }

    static calculateState() {
        return {
            apostilas: ApostilasStore.getState(),
            app: AppStore.getState(),
            login: LoginStore.getState(),
            token: TokenStore.getState(),
            city: CityStore.getState(),
            credenciamento: CredenciamentoStore.getState(),
            eventsStore: EventsStore.getState(),
            nucleo: NucleoStore.getState(),
            dialog: DialogStore.getState(),
            participants: ParticipantesStore.getState(),
            importacao: ImportacaoStore.getState(),
            importacaoProdutos: ImportacaoProdutosStore.getState(),
            user: UserStore.getState(),
            produtos: ProdutosStore.getState(),
            venda: LojaVendaStore.getState(),
            caixa: LojaCaixaStore.getState(),
            relatorioDashboard: RelatorioDashboardStore.getState(),
            relatorioVendasDosNucleos: RelatorioVendasDosNucleosStore.getState(),
            relatorioVendasParaNucleos: RelatorioVendasParaNucleosStore.getState(),
            relatorioVendasPorProdutos: RelatorioVendasPorProdutosStore.getState(),
            distribuicaoVendas: DistribuicaoVendasStore.getState(),
            acumuladoVendas: AcumuladoVendasStore.getState(),
            presenca: PresencaStore.getState(),
            expedicao: LojaExpedicaoStore.getState(),
            perfis: PerfisStore.getState(),
            users: UsersStore.getState(),
            loja: LojaStore.getState(),
            produtosGerencia: ProdutosGerenciaStore.getState(),
            emailEditor: EmailEditorStore.getState(),
            sorteio: SorteioStore.getState(),
            pedidos: LojaPedidosStore.getState(),

            events: {
                onUpdateText: Actions.updateText.bind(Actions),
                onLogin: Actions.login.bind(Actions),
                onVerifyCpf: Actions.verifyCpf.bind(Actions),
                onPrintBadge: Actions.printBadge.bind(Actions),
                onLinkCourseware: Actions.linkCourseware.bind(Actions),
                onChooseMenu: Actions.chooseMenu.bind(Actions),
                onSelectEvent: Actions.selectEvent.bind(Actions),
                onSelectCourseForCoursewares: Actions.selectCourseForCourseware.bind(Actions),
                onSelectEventForParticipants: Actions.selectEventForParticipants.bind(Actions),
                onPrintTicket: Actions.printTicket.bind(Actions),
                onError: Actions.error.bind(Actions),
                onShowDialog: Actions.showDialog.bind(Actions),
                onCloseDialog: Actions.closeDialog.bind(Actions),
                onImportSheet: Actions.importSheet.bind(Actions),
                onImportSheetProdutos: Actions.importSheetProducts.bind(Actions),
                onSelectEventForImportacao: Actions.selectEventForImportacao.bind(Actions),
                toCredenciamento: Actions.toCredenciamento.bind(Actions),
                onSelectRelatorio: Actions.selectRelatorio.bind(Actions),
                onDownloadCsv: Actions.downloadCsv.bind(Actions),
                onSelectCategoria: Actions.selectCategoria.bind(Actions),
                onSelectNucleo: Actions.selectNucleo.bind(Actions),
                onUpdateCartItems: Actions.updateCartItems.bind(Actions),
                onCloseCart: Actions.closeCart.bind(Actions),
                onDeleteCart: Actions.deleteCart.bind(Actions),
                onSelectOpenOrder: Actions.selectOpenOrder.bind(Actions),
                onUpdatePayment: Actions.updatePayment.bind(Actions),
                onCloseOrder: Actions.closeOrder.bind(Actions),
                onPrintOrder: Actions.printOrder.bind(Actions),
                onSelectClosedOrder: Actions.selectClosedOrder.bind(Actions),
                onDeliverOrder: Actions.deliverOrder.bind(Actions),
                onShowSwal: Actions.showSwal.bind(Actions),
                onCloseSwal: Actions.closeSwal.bind(Actions),
                onFindClientName: Actions.findClientName.bind(Actions),
                onUpdateOrdersLists: Actions.updateOrdersLists.bind(Actions),
                onUpdateEmailEditor: Actions.updateEmailEditor.bind(Actions),
                onUpdateLotteryConfig: Actions.updateLotteryConfig.bind(Actions),
                onConfigureLottery: Actions.configureLottery.bind(Actions),
                onAddLotteryWinner: Actions.addLotteryWinner.bind(Actions),
                onCloseLottery: Actions.closeLottery.bind(Actions),
                onRunLottery: Actions.runLottery.bind(Actions),
                onListParticipants: Actions.listParticipants.bind(Actions),
                onSelectPaidOrder: Actions.selectPaidOrder.bind(Actions),
                onListPaidOrders: Actions.listPaidOrders.bind(Actions),
                onListAmountBySlot: Actions.listAmountBySlot.bind(Actions),
                onUpdateDashboard: Actions.updateDashboard.bind(Actions),
            },

            menuItems: [
                {
                    name: 'Credenciamento',
                    type: AdminPageTypes.CREDENCIAMENTO,
                    responsive: false,
                    permissions: [
                        Permissions.SUBSCRIPTION,
                    ],
                },
                {
                    name: 'Participantes',
                    type: AdminPageTypes.PARTICIPANTES_LIMITED,
                    responsive: false,
                    permissions: [
                        Permissions.SUBSCRIPTION,
                    ],
                },
                {
                    name: 'Importar Participantes',
                    type: AdminPageTypes.IMPORTACAO,
                    responsive: false,
                    permissions: [
                        Permissions.IMPORT_PARTICIPANTS
                    ],
                },
                {
                    name: 'Importar Produtos e Cursos',
                    type: AdminPageTypes.IMPORTACAO_PRODUTOS,
                    responsive: false,
                    permissions: [
                        Permissions.IMPORT_PRODUCTS
                    ],
                },
                {
                    name: 'Gerenciar Participantes',
                    type: AdminPageTypes.PARTICIPANTES,
                    responsive: false,
                    permissions: [
                        Permissions.PARTICIPANT
                    ],
                },
                {
                    name: 'Lista de Presença',
                    type: AdminPageTypes.PRESENCA,
                    responsive: false,
                    permissions: [
                        Permissions.ATTENDANCE,
                        Permissions.REPORT,
                    ],
                },
                {
                    name: 'Perfis de Usuários',
                    type: AdminPageTypes.PERFIS,
                    responsive: false,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                },
                {
                    name: 'Usuários',
                    type: AdminPageTypes.USUARIOS,
                    responsive: false,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                },
                {
                    name: 'Impressoras',
                    type: AdminPageTypes.IMPRESSORAS,
                    responsive: false,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                },
                {
                    name: 'Países',
                    type: AdminPageTypes.PAISES,
                    responsive: false,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                    render: BuildTypes.FULL === VERSION,
                },
                {
                    name: 'Cidades',
                    type: AdminPageTypes.CIDADES,
                    responsive: false,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                    render: BuildTypes.FULL === VERSION,
                },
                {
                    name: 'Núcleos',
                    type: AdminPageTypes.NUCLEOS,
                    responsive: false,
                    permissions: [
                        Permissions.CENTER,
                    ],
                    render: BuildTypes.FULL === VERSION,
                },
                {
                    name: 'Cursos',
                    type: AdminPageTypes.CURSOS,
                    responsive: false,
                    permissions: [
                        Permissions.COURSE
                    ],
                    render: BuildTypes.FULL === VERSION,
                },
                {
                    name: 'Apostilas',
                    type: AdminPageTypes.APOSTILAS,
                    responsive: false,
                    permissions: [
                        Permissions.COURSEWARE
                    ],
                    render: BuildTypes.FULL === VERSION,
                },
                {
                    name: 'Eventos',
                    type: AdminPageTypes.EVENTS,
                    responsive: false,
                    permissions: [
                        Permissions.EVENT
                    ],
                },
                {
                    name: 'Produtos',
                    type: AdminPageTypes.PRODUTOS,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.PRODUCT
                    ],
                },
                {
                    name: 'Vendas',
                    type: AdminPageTypes.VENDA,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.STORE
                    ],
                },
                {
                    name: 'Caixa',
                    type: AdminPageTypes.CAIXA,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.CHECKOUT
                    ],
                },
                {
                    name: 'Expedição',
                    type: AdminPageTypes.EXPEDICAO,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.DELIVERY
                    ],
                },
                {
                    name: 'Loja (Vendas + Caixa)',
                    type: AdminPageTypes.VENDA_CAIXA,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.STORE_CHECKOUT
                    ],
                },
                {
                    name: 'Loja (Caixa + Expedição)',
                    type: AdminPageTypes.CAIXA_EXPEDICAO,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.CHECKOUT_DELIVERY
                    ],
                },
                {
                    name: 'Loja (Vendas + Caixa + Expedição)',
                    type: AdminPageTypes.VENDA_CAIXA_EXPEDICAO,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.STORE_CHECKOUT_DELIVERY
                    ],
                },
                {
                    name: 'Pedidos pagos',
                    type: AdminPageTypes.PEDIDOS_PAGOS,
                    responsive: false,
                    profiles: null,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                },
                {
                    name: 'Relatório Dashboard',
                    type: AdminPageTypes.RELATORIO_DASHBOARD,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Vendas Totais',
                    type: AdminPageTypes.RELATORIO_VENDAS_TOTAIS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Vendas dos Núcleos',
                    type: AdminPageTypes.RELATORIO_VENDAS_DOS_NUCLEOS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Compras dos Participantes',
                    type: AdminPageTypes.RELATORIO_VENDAS_PARA_NUCLEOS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Vendas por Produtos',
                    type: AdminPageTypes.RELATORIO_VENDAS_POR_PRODUTOS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Carrinhos Pagos',
                    type: AdminPageTypes.RELATORIO_CARRINHOS_PAGOS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Vendas por Pagamento',
                    type: AdminPageTypes.RELATORIO_VENDAS_POR_PAGAMENTO,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Compradores por Produto',
                    type: AdminPageTypes.RELATORIO_COMPRADORES_POR_PRODUTO,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Relatório de Apostilas por Núcleo',
                    type: AdminPageTypes.RELATORIO_APOSTILAS_POR_NUCLEO,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Gráfico de distribuição de vendas',
                    type: AdminPageTypes.DISTRIBUICAO_VENDAS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Gráfico do acumulado de vendas',
                    type: AdminPageTypes.ACUMULADO_VENDAS,
                    responsive: false,
                    permissions: [
                        Permissions.REPORT
                    ],
                },
                {
                    name: 'Enviar e-mails',
                    type: AdminPageTypes.EMAILS,
                    responsive: false,
                    permissions: [
                        Permissions.SYSTEM
                    ],
                    render: BuildTypes.PROD !== process.env.NODE_ENV,
                },
                {
                    name: 'Configurar sorteio',
                    type: AdminPageTypes.SORTEIO,
                    responsive: false,
                    permissions: [
                        Permissions.LOTTERY
                    ],
                },
                {
                    name: 'Sair',
                    type: AdminPageTypes.LOGOUT,
                    responsive: true,
                    profiles: null,
                    permissions: null,
                }
            ]
        };
    }

    render() {
        return (
            <div id="app-container">
                <Login {...this.state} />
                <Admin {...this.state} />
                <Lottery {...this.state} />
                <Dialog {...this.state} />
            </div>
        );
    }
}

export default Container.create(AppContainer);



// WEBPACK FOOTER //
// src/AppContainer.js